import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { formatTrendChange, type LowerIsBetterTrend } from "@/utils/analyticsTrend";
import { formatPercentFromWhole } from "@/utils/number";

type Trend = LowerIsBetterTrend;

export const useTrendCardPresentation = (dateRange: string) => {
  const { t, i18n } = useTranslation();

  return useCallback(
    (
      trend: Trend,
      formatPreviousValue: (value: number, locale: string) => string,
      comparisonProgress?: string,
    ) => {
      const locale = i18n.resolvedLanguage || i18n.language;
      return {
        ...trend,
        text: formatTrendChange(
          trend,
          (value) => formatPreviousValue(value, locale),
          (value) => formatPercentFromWhole(value, locale),
          t("common.analytics.trends.noChange"),
        ),
        tooltip:
          trend.status === "ready"
            ? t("common.analytics.trends.tooltip", {
                dateRange,
                previousValue: [
                  formatPreviousValue(trend.previousValue, locale),
                  comparisonProgress,
                ]
                  .filter(Boolean)
                  .join(" • "),
              })
            : undefined,
      };
    },
    [dateRange, i18n.language, i18n.resolvedLanguage, t],
  );
};
